import React from 'react';
import Card from 'src/components/Card';
import Button from 'src/components/Button';
import FontAwesomeIcon from 'src/components/Icon';
import Skeleton from 'src/components/Skeleton/Skeleton';
import { convertTime } from 'src/helpers/time';
import './ServiceRequestAppointmentCard.scss';

interface ServiceRequestAppointmentCardProps {
  serviceRequest: any;
  loading?: boolean;
  handleStatusChange: (statusFormData: any, serviceRequestId: any) => void;
}

const ServiceRequestAppointmentCard = ({
  serviceRequest,
  loading,
  handleStatusChange,
}: ServiceRequestAppointmentCardProps) => {
  if (loading) {
    return (
     <></>
    );
  }

  const isEmptyAppointment: boolean =
    serviceRequest.appointment.id === '00000000-0000-0000-0000-000000000000';

  const formatAppointmentDate = () => {
    if (isEmptyAppointment) return 'No Appointment';
    return convertTime(serviceRequest.appointment.scheduledAt, 'dddd MM/DD/YYYY');
  };

  const formatAppointmentTime = () => {
    if (isEmptyAppointment) return '';
    return convertTime(serviceRequest.appointment.scheduledAt, 'h:mm A');
  };

  const scheduleButton = isEmptyAppointment ? (
    <Button
      size="tiny"
      label="Schedule"
      outline="teal"
      onClick={() =>
        handleStatusChange({ name: 'Scheduled' }, serviceRequest.id)
      }
    />
  ) : null;

  const title = (
    <div className="sr-detail-card-title-with-action">
      <span>Appointment</span>
      {scheduleButton}
    </div>
  );

  return (
    <Card
      title={title}
      body={
        <div className="sr-detail-card-row">
          <div className="serviceRequest__appointment">
            <div className="serviceRequest__appointmentIcon">
              <FontAwesomeIcon glyph="calendar" weight="regular" />
            </div>
            <div>
              {formatAppointmentDate()}
              <br />
              {formatAppointmentTime()}
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ServiceRequestAppointmentCard;